import React from 'react';
import { useInfoCollectionFormCtx } from 'pages/Main/QRScreens/hooks/useInfoCollectionFormCtx';
import { FormTextField } from 'components/__v5__/FormTextField';

export const LastName: React.FC = () => {
  const { control } = useInfoCollectionFormCtx();
  return (
    <FormTextField
      name="lastName"
      control={control}
      label="Last Name*"
      placeholder="Last Name*"
      showError
    />
  );
};
